"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatOutput = exports.isValidDateTime = exports.isValidDate = exports.isValidTime = exports.parseTimeFormat = exports.getDelimiters = exports.setDateFormat = exports.setTimeFormat = exports.getMonths = exports.getWeekDays = exports.isEmptyObject = exports.getFormat = void 0;

var _intlFormats = require("./intl-formats");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var getFormat = function getFormat(locale) {
  switch (locale) {
    case 'sk':
      return {
        allFormats: ['D.M.YYYY', 'DD.MM.YYYY'],
        dateFormat: 'DD.MM.YYYY',
        dateFormatPosition: ['day', 'month', 'year'],
        timeFormat: 'H:mm:ss',
        delimiter: '.',
        startingWeekday: 1
      };

    case 'de':
      return {
        allFormats: ['D.M.YYYY', 'DD.MM.YYYY'],
        dateFormat: 'DD.MM.YYYY',
        dateFormatPosition: ['day', 'month', 'year'],
        timeFormat: 'H:mm:ss',
        delimiter: '.',
        startingWeekday: 1
      };

    case 'es':
      return {
        allFormats: ['D/M/YYYY', 'DD/MM/YYYY'],
        dateFormat: 'DD/MM/YYYY',
        dateFormatPosition: ['day', 'month', 'year'],
        timeFormat: 'H:mm:ss',
        delimiter: '/',
        startingWeekday: 1
      };

    case 'ko':
      return {
        allFormats: ['YYYY.M.D', 'YYYY.MM.DD'],
        dateFormat: 'YYYY.MM.DD',
        dateFormatPosition: ['year', 'month', 'day'],
        timeFormat: 'H:mm:ss',
        delimiter: '.',
        startingWeekday: 1
      };

    case 'ru':
      return {
        allFormats: ['D.M.YYYY', 'DD.MM.YYYY'],
        dateFormat: 'DD.MM.YYYY',
        dateFormatPosition: ['day', 'month', 'year'],
        timeFormat: 'H:mm:ss',
        delimiter: '.',
        startingWeekday: 1
      };

    case 'vi':
      return {
        allFormats: ['D/M/YYYY', 'DD/MM/YYYY'],
        dateFormat: 'DD/MM/YYYY',
        dateFormatPosition: ['day', 'month', 'year'],
        timeFormat: 'H:mm:ss',
        delimiter: '/',
        startingWeekday: 1
      };

    case 'zh_CN':
    case 'zh':
      return {
        allFormats: ['YYYY.M.D', 'YYYY.MM.DD'],
        dateFormat: 'YYYY.MM.DD',
        dateFormatPosition: ['year', 'month', 'day'],
        timeFormat: 'H:mm:ss',
        delimiter: '.',
        startingWeekday: 1
      };

    default:
      // we will use EN locale settings as fallback.
      return {
        allFormats: ['M/D/YYYY', 'MM/DD/YYYY'],
        dateFormat: 'MM/DD/YYYY',
        dateFormatPosition: ['month', 'day', 'year'],
        timeFormat: 'h:mm:ss',
        delimiter: '/',
        startingWeekday: 0
      };
  }
};

exports.getFormat = getFormat;
var dateFormats = {
  isInRange: function isInRange(value, min, max) {
    return value >= min && value <= max;
  },
  // whether the value meets Min & Max condition
  displayCorrectDigits: function displayCorrectDigits(number, digitCount) {
    // Corrects the value - adds necessary
    var numberLength = "".concat(number).length;

    if (numberLength <= digitCount) {
      return "".concat('0'.repeat(digitCount - numberLength)).concat(number);
    }

    return "".concat(number);
  },
  findKey: function findKey(key, set) {
    return set[key];
  },
  // returns the correct formatObject
  days: {
    DD: {
      min: 1,
      max: 31,
      minDigit: 2
    },
    D: {
      min: 1,
      max: 31,
      minDigit: 1
    }
  },
  months: {
    MM: {
      min: 1,
      max: 12,
      minDigit: 2
    },
    M: {
      min: 1,
      max: 12,
      minDigit: 1
    }
  },
  years: {
    YYYY: {
      min: 0,
      max: 9999,
      minDigit: 1
    }
  }
};
var timeFormats = {
  isInRange: function isInRange(value, min, max) {
    return value >= min && value <= max;
  },
  // whether the value meets Min & Max condition
  displayCorrectDigits: function displayCorrectDigits(number, digitCount) {
    // Corrects the value - adds necessary or removes unnecessary digits
    var numberLength = "".concat(number).length;

    if (numberLength <= digitCount) {
      return "".concat('0'.repeat(digitCount - numberLength)).concat(number);
    }

    return "".concat(Math.floor(number / (10 * digitCount)));
  },
  findKey: function findKey(key, set) {
    return set[key];
  },
  // returns the correct formatObject
  hours: {
    HH: {
      min: 0,
      max: 23,
      digit: 2
    },
    H: {
      min: 0,
      max: 23,
      digit: 1
    },
    KK: {
      min: 1,
      max: 24,
      digit: 2
    },
    K: {
      min: 1,
      max: 24,
      digit: 1
    },
    hh: {
      min: 1,
      max: 12,
      digit: 2
    },
    h: {
      min: 1,
      max: 12,
      digit: 1
    }
  },
  minutes: {
    mm: {
      min: 0,
      max: 59,
      digit: 2
    },
    m: {
      min: 0,
      max: 59,
      digit: 1
    }
  },
  seconds: {
    ss: {
      min: 0,
      max: 59,
      digit: 2
    },
    s: {
      min: 0,
      max: 59,
      digit: 1
    }
  },
  milliseconds: {
    SSS: {
      min: 0,
      max: 999,
      digit: 3
    },
    SS: {
      min: 0,
      max: 99,
      digit: 2
    },
    S: {
      min: 0,
      max: 9,
      digit: 1
    }
  },
  ampm: {
    A: {
      isValid: function isValid(value) {
        return value.toLowerCase() === 'am' || value.toLowerCase() === 'pm';
      }
    }
  }
};

var isEmptyObject = function isEmptyObject(obj) {
  return Object.entries(obj).length === 0;
};

exports.isEmptyObject = isEmptyObject;

var getWeekDays = function getWeekDays(_ref) {
  var format = _ref.format,
      locale = _ref.locale;
  var result = [];
  var day = new Date('2019-06-09T13:00:00.000Z'); // <-- THIS IS SUNDAY

  var formatter = new Intl.DateTimeFormat([locale], {
    weekday: format
  });

  for (var i = 0; i < 7; i += 1) {
    result.push(formatter.format(day));
    day.setDate(day.getDate() + 1);
  }

  var _getFormat = getFormat(locale),
      startingWeekday = _getFormat.startingWeekday;

  for (var _i = 0; _i < startingWeekday; _i += 1) {
    result.push(result.shift());
  }

  return result;
};

exports.getWeekDays = getWeekDays;

var getMonths = function getMonths(_ref2) {
  var format = _ref2.format,
      locale = _ref2.locale;
  var result = [];
  var month = new Date('2020-01-01T13:00:00.000Z');
  var formatter = new Intl.DateTimeFormat([locale], {
    month: format
  });

  for (var i = 0; i < 12; i += 1) {
    result.push(formatter.format(month));
    month.setMonth(month.getMonth() + 1);
  }

  return result;
};

exports.getMonths = getMonths;

var setTimeFormat = function setTimeFormat(format) {
  var appendResult = function appendResult(result, value) {
    var delimiter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ':';

    if (result && result.length) {
      return result + delimiter + value;
    }

    return value;
  };

  var result = '';

  if (format.hour) {
    if (format.hour12) {
      result += format.hour.toLowerCase() === 'numeric' ? 'h' : 'hh';
    } else {
      result += format.hour.toLowerCase() === 'numeric' ? 'H' : 'HH';
    }
  }

  if (format.minute) {
    result = appendResult(result, format.minute.toLowerCase() === 'numeric' ? 'm' : 'mm');
  }

  if (format.second) {
    result = appendResult(result, format.second.toLowerCase() === 'numeric' ? 's' : 'ss');
  }

  if (format.millisecond && ("".concat(format.millisecond) === '1' || "".concat(format.millisecond) === '2' || "".concat(format.millisecond) === '3')) {
    result = appendResult(result, 'S'.repeat(parseInt(format.millisecond, 10)), '.');
  }

  return result;
};

exports.setTimeFormat = setTimeFormat;

var setDateFormat = function setDateFormat(format, localeFormat) {
  var appendResult = function appendResult(result, value) {
    var delimiter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';

    if (result && result.length) {
      return result + delimiter + value;
    }

    return value;
  };

  var translate = {
    day: 'DD',
    month: 'MM',
    year: 'YYYY'
  };
  var delimiter = localeFormat.delimiter,
      dateFormatPosition = localeFormat.dateFormatPosition;
  var result = '';

  for (var i = 0; i < dateFormatPosition.length; i += 1) {
    if (format[dateFormatPosition[i]]) {
      result = appendResult(result, translate[dateFormatPosition[i]], delimiter);
    }
  }

  return result;
};

exports.setDateFormat = setDateFormat;

var getDelimiters = function getDelimiters() {
  return {
    date: ['.', '/', '-'],
    time: [':', '-', '.', ',']
  };
};
/**
 *
 * @param formatParts
 * @param partKey
 * @returns {null|{format: *, value: (*|string)}}
 */


exports.getDelimiters = getDelimiters;

var findTimeFormatPart = function findTimeFormatPart(formatParts, partKey) {
  for (var i = 0; i < formatParts.length; i += 1) {
    if (timeFormats.findKey(formatParts[i], timeFormats[partKey])) {
      return {
        format: formatParts[i],
        value: timeFormats.displayCorrectDigits(0, timeFormats[partKey][formatParts[i]].digit)
      };
    }
  }

  return null;
};

var findAmPm = function findAmPm(_ref3) {
  var _hour$format, _hour$format2;

  var valueParts = _ref3.valueParts,
      hour = _ref3.hour;

  if (!hour || !(((_hour$format = hour.format) === null || _hour$format === void 0 ? void 0 : _hour$format.toLowerCase()) === 'hh' || ((_hour$format2 = hour.format) === null || _hour$format2 === void 0 ? void 0 : _hour$format2.toLowerCase()) === 'h')) {
    return null;
  }

  for (var i = 0; i < valueParts.length; i += 1) {
    if (isNaN(parseInt(valueParts[i], 10))) {
      if (timeFormats.ampm.A.isValid(valueParts[i])) {
        return {
          format: 'A',
          value: valueParts[i]
        };
      }

      return {
        format: 'A',
        value: valueParts[i],
        error: true
      };
    }
  }

  return {
    format: 'A',
    value: 'am'
  };
};

var parseTimeFormat = function parseTimeFormat(format, value) {
  var _getDelimiters = getDelimiters(),
      time = _getDelimiters.time;

  var valueParts = splitByDelimiters(value, time);
  var formatParts = splitByDelimiters(format, time);
  var hour = null;
  var minute = null;
  var second = null;
  var millisecond = null;
  var maxIterationLength = Number(valueParts.length <= formatParts.length ? valueParts.length : formatParts.length);

  for (var i = 0; i < maxIterationLength; i += 1) {
    if (timeFormats.findKey(formatParts[i], timeFormats.hours)) {
      hour = {
        format: formatParts[i],
        value: valueParts[i]
      };
    } else if (timeFormats.findKey(formatParts[i], timeFormats.minutes)) {
      minute = {
        format: formatParts[i],
        value: valueParts[i]
      };
    } else if (timeFormats.findKey(formatParts[i], timeFormats.seconds)) {
      second = {
        format: formatParts[i],
        value: valueParts[i]
      };
    } else if (timeFormats.findKey(formatParts[i], timeFormats.milliseconds)) {
      millisecond = {
        format: formatParts[i],
        value: valueParts[i]
      };
    }
  }

  if (valueParts.length <= formatParts.length) {
    var hourPart = findTimeFormatPart(formatParts, 'hours');
    hour = (!hour || !hour.value) && hourPart ? hourPart : hour;
    var minutePart = findTimeFormatPart(formatParts, 'minutes');
    minute = (!minute || !minute.value) && minutePart ? minutePart : minute;
    var secondPart = findTimeFormatPart(formatParts, 'seconds');
    second = (!second || !second.value) && secondPart ? secondPart : second;
    var millisecondPart = findTimeFormatPart(formatParts, 'milliseconds');
    millisecond = (!millisecond || !millisecond.value) && millisecondPart ? millisecondPart : millisecond;
  }

  var ampm = findAmPm({
    valueParts: valueParts,
    hour: hour
  });

  if (ampm === null || ampm === void 0 ? void 0 : ampm.error) {
    return null;
  }

  return hour || minute || second || millisecond || ampm ? {
    hour: hour,
    minute: minute,
    second: second,
    millisecond: millisecond,
    ampm: ampm
  } : null;
};

exports.parseTimeFormat = parseTimeFormat;

var parseDateFormat = function parseDateFormat(format, value) {
  var _getDelimiters2 = getDelimiters(),
      date = _getDelimiters2.date;

  var valueParts = splitByDelimiters(value, date);
  var formatParts = splitByDelimiters(format, date);

  if (valueParts.length !== formatParts.length) {
    return null;
  }

  var day = null;
  var month = null;
  var year = null;

  for (var i = 0; i < valueParts.length; i += 1) {
    if (dateFormats.findKey(formatParts[i], dateFormats.days)) {
      day = {
        format: formatParts[i],
        value: valueParts[i]
      };
    } else if (dateFormats.findKey(formatParts[i], dateFormats.months)) {
      month = {
        format: formatParts[i],
        value: valueParts[i]
      };
    } else if (dateFormats.findKey(formatParts[i], dateFormats.years)) {
      year = {
        format: formatParts[i],
        value: valueParts[i]
      };
    }
  }

  return day || month || year ? {
    day: day,
    month: month,
    year: year
  } : null;
};

var splitByDelimiters = function splitByDelimiters(text, delimiters) {
  var result = [];
  var part = '';

  for (var i = 0; i < text.length; i += 1) {
    if (delimiters.indexOf(text[i]) !== -1) {
      result.push(part);
      part = '';
    } else {
      part += text[i];
    }
  }

  result.push(part);
  return result;
};

var checkValue = function checkValue(_ref4) {
  var value = _ref4.value,
      format = _ref4.format,
      type = _ref4.type,
      formats = _ref4.formats;

  if (!format || !format.length) {
    return true;
  }

  if (!/^\d+$/.test(value)) {
    return false;
  }

  var val = typeof value === 'number' ? value : parseInt(value, 10);
  var f = formats[type] ? formats[type][format] : false;
  return f && formats.isInRange(val, f.min, f.max) ? formats.displayCorrectDigits(val, f.digit) : false;
};

var checkValueAmpm = function checkValueAmpm(value, format) {
  if (!format || !format.length) {
    return null;
  }

  var f = timeFormats.ampm[format];
  return f ? f.isValid(value) : null;
};

var replaceAll = function replaceAll(target, search, replacement) {
  return target.replace(new RegExp(search, 'g'), replacement);
};

var isValidTime = function isValidTime(value, _ref5) {
  var format = _ref5.format,
      language = _ref5.language;

  if (format && _typeof(format) === 'object') {
    return (0, _intlFormats.isValidDateTimeIntl)({
      value: value,
      format: format,
      language: language
    });
  }

  var splitValue = value.split(' ');

  if (splitValue.length !== 1) {
    value = replaceAll(value, ' ', '.');
  }

  if (value instanceof Date && !isNaN(value.getMonth())) {
    return {
      isValid: true,
      dateRaw: value.toISOString(),
      date: new Date(value)
    };
  }

  if (!format || !format.length) {
    return _intlFormats.NOT_VALID;
  }

  var parsedValues = parseTimeFormat(format, value);

  if (!parsedValues) {
    return _intlFormats.NOT_VALID;
  }

  var hour = parsedValues.hour,
      minute = parsedValues.minute,
      second = parsedValues.second,
      millisecond = parsedValues.millisecond,
      ampm = parsedValues.ampm;

  if ((hour ? checkValue({
    value: hour.value,
    format: hour.format,
    type: 'hours',
    formats: timeFormats
  }) : true) && (minute ? checkValue({
    value: minute.value,
    format: minute.format,
    type: 'minutes',
    formats: timeFormats
  }) : true) && (second ? checkValue({
    value: second.value,
    format: second.format,
    type: 'seconds',
    formats: timeFormats
  }) : true) && (millisecond ? checkValue({
    value: millisecond.value,
    format: millisecond.format,
    type: 'milliseconds',
    formats: timeFormats
  }) : true) && (ampm ? checkValueAmpm(ampm.value, ampm.format) : true)) {
    var currentDate = new Date();
    var ampmCheckedHourValue = ampm && ampm.value.toLowerCase() === 'pm' ? "".concat(parseInt(hour.value, 10) + 12) : hour.value;
    var year = currentDate.getFullYear();
    var month = timeFormats.displayCorrectDigits(currentDate.getMonth() + 1, 2);
    var date = timeFormats.displayCorrectDigits(currentDate.getDate(), 2);
    var hours = hour ? timeFormats.displayCorrectDigits(ampmCheckedHourValue, 2) : currentDate.getHours();
    var minutes = minute ? timeFormats.displayCorrectDigits(minute.value, 2) : currentDate.getMinutes();
    var seconds = second ? timeFormats.displayCorrectDigits(second.value, 2) : currentDate.getSeconds();
    var milliseconds = millisecond ? timeFormats.displayCorrectDigits(millisecond.value, 1) : currentDate.getMilliseconds();
    var newDateRaw = "".concat(year, "-").concat(month, "-").concat(date, "T").concat(hours, ":").concat(minutes, ":").concat(seconds, ".").concat(milliseconds, "Z");
    var newDate = new Date(newDateRaw);
    newDate.setMinutes(newDate.getMinutes() + currentDate.getTimezoneOffset());
    return {
      isValid: true,
      dateRaw: new Date(newDate).toISOString(),
      date: newDate
    };
  }

  return _intlFormats.NOT_VALID;
};

exports.isValidTime = isValidTime;

var checkLeapYear = function checkLeapYear(_ref6) {
  var years = _ref6.years,
      months = _ref6.months,
      days = _ref6.days;
  return new Date("".concat(months, "/").concat(days, "/").concat(years)).getMonth() === 2;
};

var isValidDate = function isValidDate(value, _ref7) {
  var format = _ref7.format,
      language = _ref7.language;

  if (format && _typeof(format) === 'object') {
    return (0, _intlFormats.isValidDateTimeIntl)({
      value: value,
      format: format,
      language: language
    });
  }

  if (value instanceof Date && !isNaN(value.getMonth())) {
    return {
      isValid: true,
      dateRaw: value.toISOString(),
      date: new Date(value)
    };
  }

  if (!format || !format.length) {
    return _intlFormats.NOT_VALID;
  }

  var parsedValues = parseDateFormat(format, value);

  if (!parsedValues) {
    return _intlFormats.NOT_VALID;
  }

  var day = parsedValues.day,
      month = parsedValues.month,
      year = parsedValues.year;

  if ((day ? checkValue({
    value: day.value,
    format: day.format,
    type: 'days',
    formats: dateFormats
  }) : true) && (month ? checkValue({
    value: month.value,
    format: month.format,
    type: 'months',
    formats: dateFormats
  }) : true) && (year ? checkValue({
    value: year.value,
    format: year.format,
    type: 'years',
    formats: dateFormats
  }) : true)) {
    var currentTime = new Date();
    var years = year ? dateFormats.displayCorrectDigits(year.value, 4) : currentTime.getFullYear();
    var months = month ? dateFormats.displayCorrectDigits(month.value, 2) : currentTime.getMonth() + 1;
    var days = day ? dateFormats.displayCorrectDigits(day.value, 2) : currentTime.getDate();
    var hours = timeFormats.displayCorrectDigits(currentTime.getHours(), 2);
    var minutes = timeFormats.displayCorrectDigits(currentTime.getMinutes(), 2);
    var seconds = timeFormats.displayCorrectDigits(currentTime.getSeconds(), 2);
    var milliseconds = timeFormats.displayCorrectDigits(currentTime.getMilliseconds(), 3);
    var newDate = "".concat(years, "-").concat(months, "-").concat(days, "T").concat(hours, ":").concat(minutes, ":").concat(seconds, ".").concat(milliseconds, "Z");

    if (checkLeapYear({
      years: years,
      months: months,
      days: days
    })) {
      return _intlFormats.NOT_VALID;
    }

    return {
      isValid: true,
      dateRaw: newDate,
      date: new Date(newDate)
    };
  }

  return _intlFormats.NOT_VALID;
};

exports.isValidDate = isValidDate;

var isValidDateTime = function isValidDateTime(value, _ref8) {
  var format = _ref8.format,
      language = _ref8.language;

  if (format && _typeof(format) === 'object') {
    return (0, _intlFormats.isValidDateTimeIntl)({
      value: value,
      format: format,
      language: language
    });
  }

  if (value instanceof Date && !isNaN(value.getMonth())) {
    return {
      isValid: true,
      dateRaw: value.toISOString(),
      date: value
    };
  }

  if (!format || !format.length) {
    return _intlFormats.NOT_VALID;
  }

  var valueParts = value.trim().split(' ');
  var formatParts = format.trim().split(' ');

  if (valueParts.length > 2 && (valueParts[valueParts.length - 1].toLowerCase() === 'am' || valueParts[valueParts.length - 1].toLowerCase() === 'pm')) {
    var ampm = valueParts.pop();
    valueParts[valueParts.length - 1] += ".".concat(ampm);
  }

  if (valueParts.length !== 2 || formatParts.length !== 2) {
    return _intlFormats.NOT_VALID;
  }

  var validDate = isValidDate(valueParts[0], {
    format: formatParts[0],
    language: language
  });
  var validTime = isValidTime(valueParts[1], {
    format: formatParts[1],
    language: language
  });

  if (!validDate || !validDate.isValid || !validTime || !validTime.isValid) {
    return _intlFormats.NOT_VALID;
  }

  var dateRaw = new Date("".concat(validDate.dateRaw.split('T')[0], "T").concat(validTime.dateRaw.split('T')[1]));
  return {
    isValid: true,
    dateRaw: dateRaw,
    date: new Date(dateRaw)
  };
};

exports.isValidDateTime = isValidDateTime;

var formatMonths = function formatMonths(_ref9) {
  var value = _ref9.value,
      language = _ref9.language,
      tempResult = _ref9.tempResult;
  var result = tempResult;
  result = result.replace('MMMM', new Intl.DateTimeFormat(language, {
    month: 'long'
  }).format(value));
  result = result.replace('MMM', new Intl.DateTimeFormat(language, {
    month: 'short'
  }).format(value));
  return result;
};

var formatOutput = function formatOutput(_ref10) {
  var value = _ref10.value,
      format = _ref10.format,
      language = _ref10.language;

  if (!value || !(value instanceof Date) || isNaN(value.getHours())) {
    return value;
  }

  if (typeof format === 'string') {
    var result = format;
    var correctDate = dateFormats.displayCorrectDigits;
    var correctTime = timeFormats.displayCorrectDigits;
    var ampmHours = value.getHours() % 12 === 0 ? 12 : value.getHours() % 12;
    result = result.replace('HH', correctDate(value.getHours(), 2));
    result = result.replace('H', correctDate(value.getHours(), 1));
    result = result.replace('hh', correctDate(ampmHours, 2));
    result = result.replace('h', correctDate(ampmHours, 1));
    result = result.replace('KK', correctDate(value.getHours() + 1, 2));
    result = result.replace('K', correctDate(value.getHours() + 1, 1));
    result = result.replace('mm', correctDate(value.getMinutes(), 2));
    result = result.replace('m', correctDate(value.getMinutes(), 1));
    result = result.replace('ss', correctDate(value.getSeconds(), 2));
    result = result.replace('s', correctDate(value.getSeconds(), 1));
    result = result.replace('SSS', correctTime(value.getMilliseconds(), 3));
    result = result.replace('SS', correctTime(value.getMilliseconds(), 2));
    result = result.replace('S', correctTime(value.getMilliseconds(), 1));
    result = result.replace('A', '');
    result = result.replace('a', '');
    result = result.replace('DD', correctDate(value.getDate(), 2));
    result = result.replace('D', correctDate(value.getDate(), 1));
    result = result.replace('YYYY', correctDate(value.getFullYear(), 1));

    if (result.indexOf('MMM') !== -1) {
      // for 'MMM' and 'MMMM' formats (like 'Aug' or 'August')
      // This has to be at the end of the conversions, since month like May can get 'M' replaced with something else
      result = formatMonths({
        tempResult: result,
        language: language,
        value: value
      });
    } else {
      result = result.replace('MM', correctDate(value.getMonth() + 1, 2));
      result = result.replace('M', correctDate(value.getMonth() + 1, 1));
    }

    result = result.trim();

    if (format.indexOf('h') !== -1 || format.indexOf('hh') !== -1) {
      result += value.getHours() > 12 ? ' PM' : ' AM';
    }

    return result;
  }

  var formatter = new Intl.DateTimeFormat(language, format instanceof Object ? format : undefined);
  return format.millisecond ? "".concat(formatter.format(value), ".").concat(value.getMilliseconds()) : formatter.format(value);
};

exports.formatOutput = formatOutput;
//# sourceMappingURL=utils.js.map